import React from 'react';
import { Box } from '@mui/material';
// import Cart from '../../assets/cart.svg'
import Avatar from '../../assets/avater.jpg';
import Close from '../../assets/close.svg'

const SidebarNav = ({onClose}) => {
  return (
    <Box sx={{display:'flex', justifyContent:'space-between'}}>
        <img src={Close} alt="close" onClick={onClose} style={{width:'24px', height:'24px', cursor:'pointer'}}/>
        <Box sx={{display:'flex', gap:2}}>
            {/* <img src={Cart} alt="cart" /> */}
            <img src={Avatar} alt="avatar" style={{borderRadius:'50%'}}/>
        </Box>
    </Box>
  )
}

export default SidebarNav